import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function HydropowerHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1508">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/xtSWwt6J52zfYaW1YuQfeN/hydropower-facial.jpg)'
    }} data-id="element-1509" />
      <div className="absolute inset-0 bg-black/50" data-id="element-1510" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1511">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1512">
          <div className="mb-6" data-id="element-1513">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1514">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1515">
                Treatments
              </a>{' '}
              / Skin
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1516">
            Be BRIGHT
          </span>

          <h1 className="text-[36px] sm:text-5xl lg:text-[64px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1517">
            HYDROPOWER FACIAL
          </h1>

          <div className="space-y-6" data-id="element-1518">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1519">
              The HydroPOWER facial is an advanced skincare treatment that
              combines the benefits of hydrodermabrasion, hydration, and
              targeted serum infusion to rejuvenate the skin. At Be CLINICAL,
              our HydroPOWER facial is just one of our Esthetician Services
              suitable for all skin types. It addresses a variety of skin
              concerns like dullness, dryness, fine lines and uneven skin tone.
              Enjoy immediate radiance and hydration with skin that feels
              refreshed and revitalized.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1520">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}